import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SegmentedNavigationModule } from '../../../../components/segmented-navigation/segmented-navigation.module';
import { ArchivedComponent } from './archived.component';
import { BillsComponent } from './routes/bills/bills.component';
import { BillsModule } from './routes/bills/bills.module';
import { CreditsComponent } from './routes/credits/credits.component';
import { CreditsModule } from './routes/credits/credits.module';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'bills' },
      {
        path: 'bills',
        component: BillsComponent,
      },
      {
        path: 'credits',
        component: CreditsComponent,
      },
    ],
  },
];

@NgModule({
  declarations: [ArchivedComponent],
  imports: [
    CommonModule,
    RouterModule,
    BillsModule,
    CreditsModule,
    SegmentedNavigationModule,
    RouterModule.forChild(routes),
  ],
  exports: [ArchivedComponent],
})
export class ArchivedModule {}
